export default "__VITE_ASSET__DUJmJDwt__"